// extracted by mini-css-extract-plugin
module.exports = {"container":"_error_container__vJFnH","title":"_error_title__oLWAK","goBack":"_error_goBack__U4WNd","reportBug":"_error_reportBug__tsKmR"};